export const growthIntervals = [
    { key: 'i1month', label: '1 month' },
    { key: 'i2months', label: '2 months' },
    { key: 'i3months', label: '3 months' },
    { key: 'i4months', label: '4 months' },
    { key: 'i5months', label: '5 months' },
    { key: 'i6months', label: '6 months' },
] as const;

export const getGrowthIntervalLabel = (key?: string) => {
    return growthIntervals.find(item => item.key === key)?.label || key || '';
};
